import V from "gcl";
import C from "vesh";

/**
 * EMB扩展NiModuler(crypt,middler[,appname:"Ni"]),监听_m参数(等价_n),自动协助EMBAutoFactory完成SQL生成和数据查询服务和增删改三个操作
 * 按照如下优先级进行命令查找，不可跨操作级别操作，不可无权限操作
 *
 * 表结构级别
 *      库.表.类型.操作
 *      库.表.类型.*
 *      库.表.*.操作
 *      库.*.类型.操作
 *      库.*.*.操作
 *      库.*.*.*
 * 表数据级别
 *      库.表.操作
 *      库.表.edit
 *      库.*.edit
 *      库.表.nodel
 *      库.*.nodel
 *      库.*.操作
 *      库.表.*
 *      库.*.*
 * 库级别
 *      库.操作
 *      库.*
 *      *.操作
 *
 */
export const EMBModuler2 = class extends C.AModuler {
  constructor(middler, appname = "Ni", prefix = "") {
    super("EMBModuler");
    //兼容旧类参数的定义 将原有的crypt类实例删除赋值
    (arguments.length > 3 || middler.encrypt) &&
      ((middler = appname), (appname = prefix), (prefix = arguments[3]));
    const { _, __ } = pri(this, {
      middler,
      prefix,
      ni: middler
        ? new V.NiTemplateManager(middler, appname)
        : (function () {
            throw new Error("必须定义中介者middler对象");
          })(),
      idic: {},
      getCommand: async function (templatename, command) {
        command = __.prefix + command;
        if (__.idic[command])
          return await __.ni.getCommand(templatename, command);
        else if (typeof __.idic[command] == "undefined") {
          const cmd = await __.ni.getCommand(templatename, command);
          __.idic[command] = !!cmd;
          return cmd;
        } else return null;
      },
    });
  }
  async onrequest(req, rep, session) {
    const { _, __ } = pri(this);
    try {
      //todo 可以变更为真实的SQL执行 支持?_null/_null
      if (session.param("_m")) {
        const templatename = session.param("_m");
        const apps = await session.data(".belle");
        if (!apps) throw new Error(`${session.methodname}执行需要登录执行!`);
        {
          let appconfig = JSON.parse(apps);
          let now = +new Date();
          let endtime = apps.endtime;
        }
        //第三方或者我方自己调用都需要权限
        if (!session.User.Login) {
          throw new Error(`${session.methodname}执行需要登录执行!`);
        }
        session.querystring["_n"] = session.param("_m");
        session.querystring && delete session.querystring["_m"];
        session.form && (delete session.form["_m"], delete session.form["_n"]);
        //先判断是否有已经设置的正常SQL操作,如有那么直接设置执行正常SQL否则进行
        let cmd = null;
        if (session.methodname.indexOf("*") < 0) {
          cmd = await __.getCommand(templatename, session.methodname);
          if (!cmd.params && !cmd.command) {
            //确认为第三方调用 进行方法名解析 并重构命令名
            let methodname =
              `${session.url.pathname.substr(0, session.url.pathname.lastIndexOf(session.filename))}${session.status}`
                .replace(/[\\\/]/g, ".")
                .toLowerCase()
                .trim(".")
                .split(".");
            session.methodname = methodname.join(".");
            const method = methodname[methodname.length - 1];
            //过滤所有路径中带*的操作
            /**
             * 原文长度
             *      库.表.类型.操作
             *      库.表.类型.*
             *      库.表.*.操作
             *      库.*.类型.操作
             *      库.*.*.操作
             *      库.*.*.*
             *
             *      库.表.操作
             *      库.表.edit
             *      库.*.edit
             *      库.表.nodel
             *      库.*.nodel
             *      库.*.操作
             *      库.表.*(不含del drop truncate)
             *      库.*.*(不含del drop truncate)
             *
             *      库.操作
             *      库.*
             *      *.操作
             */
            cmd = await __.getCommand(templatename, methodname.join("."));
            if (!(cmd.params || cmd.command) && methodname.length != 3)
              cmd = await __.getCommand(
                templatename,
                methodname
                  .map((v, i) => (i == methodname.length - 1 ? "*" : v))
                  .join("."),
              );
            if (!(cmd.params || cmd.command))
              switch (methodname.length) {
                case 4:
                  //对所有表都有增删权限
                  cmd = await __.getCommand(
                    templatename,
                    methodname.map((v, i) => (i == 2 ? "*" : v)).join("."),
                  );
                  if (cmd.params || cmd.command) break;
                  cmd = await __.getCommand(
                    templatename,
                    methodname.map((v, i) => (i == 1 ? "*" : v)).join("."),
                  );
                  if (cmd.params || cmd.command) break;
                  cmd = await __.getCommand(
                    templatename,
                    methodname
                      .map((v, i) => (i == 1 || i == 2 ? "*" : v))
                      .join("."),
                  );
                  if (cmd.params || cmd.command) break;
                  if (!method.eq("drop")) {
                    cmd = await __.getCommand(
                      templatename,
                      `${methodname[0]}.*.*.nodel`,
                    );
                    if (cmd.params || cmd.command) break;
                  }
                  cmd = await __.getCommand(
                    templatename,
                    `${methodname[0]}.*.*.*`,
                  );
                  if (cmd.params || cmd.command) break;
                  break;
                case 3: {
                  //注意可能出现多表操作 需要设置多表联合专用会话
                  if (
                    !method.eq("select") &&
                    !method.eq("count") &&
                    !method.eq("sum")
                  ) {
                    cmd = await __.getCommand(
                      templatename,
                      methodname
                        .map((v, i) =>
                          i == methodname.length - 1 ? "edit" : v,
                        )
                        .join("."),
                    );
                    if (cmd.params || cmd.command) break;
                    cmd = await __.getCommand(
                      templatename,
                      `${methodname[0]}.*.edit`,
                    );
                    if (cmd.params || cmd.command) break;
                    if (
                      !method.eq("drop") &&
                      !method.eq("del") &&
                      !method.eq("truncate")
                    ) {
                      cmd = await __.getCommand(
                        templatename,
                        methodname
                          .map((v, i) =>
                            i == methodname.length - 1 ? "nodel" : v,
                          )
                          .join("."),
                      );
                      if (cmd.params || cmd.command) break;
                      cmd = await __.getCommand(
                        templatename,
                        `${methodname[0]}.*.nodel`,
                      );
                      if (cmd.params || cmd.command) break;
                    } else
                      //强势阻止删除数据操作 * 不包括删除清理和drop表操作
                      break;
                  }
                  cmd = await __.getCommand(
                    templatename,
                    methodname.map((v, i) => (i == 1 ? "*" : v)).join("."),
                  );
                  if (cmd.params || cmd.command) break;
                  cmd = await __.getCommand(
                    templatename,
                    methodname
                      .map((v, i) => (i == methodname.length - 1 ? "*" : v))
                      .join("."),
                  );
                  if (cmd.params || cmd.command) break;
                  cmd = await __.getCommand(
                    templatename,
                    `${methodname[0]}.*.*`,
                  );
                  if (cmd.params || cmd.command) break;
                  break;
                }
                case 2:
                  cmd = await __.getCommand(templatename, `*.${methodname[1]}`);
                  if (cmd.params || cmd.command) break;
                  break;
              }
          }
        }

        if (cmd && (cmd.params || cmd.command)) {
          if (!cmd.params["_TestPermission"])
            throw new Error(`${session.methodname}执行需要权限才能执行!`);
          let pers = (cmd.params["_TestPermission"].value || "")
            .split(",")
            .filter((v) => v.length > 0);
          let hasRight = false;
          await V.each(
            pers,
            async (v, call) => {
              if (await session.hasRight(v)) hasRight = true;
              return false;
            },
            true,
          );
          if (pers.length > 0 && !hasRight)
            throw new Error(
              `${session.methodname}执行需要${cmd.params["_TestPermission"].value}权限!`,
            );
          //数据源重置 防止无法找到对应的方法执行错误
          session.querystring["_n"] = cmd.template || session.querystring["_n"];
          const cmdparams = {};
          for (let k in cmd.params) {
            let v = cmd.params[k];
            v = (v ? v.value || (typeof v == "string" ? v : "") : "") + "";
            cmd.params[k] &&
              cmd.params[k].value !== undefined &&
              (cmdparams[k] = v);
            if (
              !k.match(/^[_\?]/) &&
              cmd.params[k].value === undefined &&
              session.form[k] === undefined
            )
              throw new Error(`${k}要求为必填!`);
          }
          //命令重置
          session.methodname = V.getValue(cmd.command, session.methodname);
          //强制某些命令的条件限制
          session.form = V.merge(session.form || {}, cmdparams);
        } else throw new Error(`${session.methodname}执行需要设置权限执行!`);
      }
    } catch (e) {
      console.log("EMBModuler", e.stack);
      throw e;
    }

    return false;
  }
};

export default {
  EMBModuler2,
};
const pri = V.pris();
